import React, { useEffect, useState } from "react";
import {
  SurgicalGuideForm,
  SurgicalGuideProps,
} from "../../../types/UploadFieldsType";
import TextInput from "../formComp/TextInputNew";
import SelectInput from "../formComp/SelectInputNew";
import ToothField from "../formComp/ToothField";

const SurgicalGuide: React.FC<SurgicalGuideProps> = ({ onChange }) => {
  const [form, setForm] = useState<SurgicalGuideForm>({
    dicomFile: "",
    stlFile: "",
    plannedImplantSites: [],
    plannedImplantManufacturer: "",
    teethExtractions: [],
    guideType: "",
    otherConsiderations: "",
    pilotDrillSize: "",
  });

  const handleToothClick = (
    type: "plannedImplantSites" | "teethExtractions",
    tooth: number
  ) => {
    const toothStr = tooth.toString();

    setForm((prev) => {
      const updated = prev[type].includes(toothStr)
        ? prev[type].filter((t) => t !== toothStr)
        : [...prev[type], toothStr];
      return { ...prev, [type]: updated };
    });
  };

  const handleChange = (field: keyof SurgicalGuideForm, value: string) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  useEffect(() => {
    onChange(form);
  }, [form, onChange]);

  return (
    <div className="w-full text-[var(--cu-text)]">
      <div className="mb-3 border-b border-[var(--cu-border)] pb-2">
        <h2 className="text-sm font-medium text-[var(--cu-accent)]">
          Surgical Guide
        </h2>
      </div>

      <div className="w-full space-y-3">
        <SelectInput
          label="DICOM file ready to upload"
          name="dicomFile"
          value={form.dicomFile}
          onChange={(e) => handleChange("dicomFile", e.target.value)}
          options={[
            { value: "Yes", label: "Yes" },
            { value: "No", label: "No" },
          ]}
        />

        <SelectInput
          label="STL file ready to upload"
          name="stlFile"
          value={form.stlFile}
          onChange={(e) => handleChange("stlFile", e.target.value)}
          options={[
            { value: "Yes", label: "Yes" },
            { value: "No", label: "No" },
          ]}
        />

        <ToothField
          label="Planned implant sites"
          toothNumbers={form.plannedImplantSites}
          onToothClick={(tooth) =>
            handleToothClick("plannedImplantSites", tooth)
          }
        />

        <TextInput
          label="Planned implant manufacturer"
          name="plannedImplantManufacturer"
          value={form.plannedImplantManufacturer}
          onChange={(e) =>
            handleChange("plannedImplantManufacturer", e.target.value)
          }
        />

        <ToothField
          label="Teeth to be extracted (if any)"
          optional
          toothNumbers={form.teethExtractions}
          onToothClick={(tooth) => handleToothClick("teethExtractions", tooth)}
        />

        <SelectInput
          label="Guide type"
          name="guideType"
          value={form.guideType}
          onChange={(e) => handleChange("guideType", e.target.value)}
          options={[
            { value: "Pilot-drill only", label: "Pilot-drill only" },
            { value: "Fully guided", label: "Fully guided" },
          ]}
        />

        {/* Conditionally render Size in mm */}
        {form.guideType === "Pilot-drill only" && (
          <TextInput
            label="Size in mm"
            name="pilotDrillSize"
            value={form.pilotDrillSize}
            onChange={(e) => handleChange("pilotDrillSize", e.target.value)}
          />
        )}
        <TextInput
          optional
          label="Other Considerations"
          name="otherConsiderations"
          value={form.otherConsiderations}
          onChange={(e) => handleChange("otherConsiderations", e.target.value)}
        />
      </div>
    </div>
  );
};

export default SurgicalGuide;
